<template>
  <ion-header class="page-header" :class="{ 'page-header--scrolled': scrolled }">
    <ion-toolbar class="page-header-toolbar">
      <ion-buttons slot="start">
        <ion-button fill="clear" class="menu-btn" @click="openMenu">
          <ion-icon :icon="menuOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title class="page-header-title">{{ title }}</ion-title>
      <ion-buttons slot="end">
        <div class="header-spacer"></div>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { menuOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';
// @ts-ignore
import { MittEmitter } from 'mitt-emitter';

export default defineComponent({
  name: 'PageHeaderWithMenu',
  components: {
    IonButton,
    IonButtons,
    IonHeader,
    IonIcon,
    IonTitle,
    IonToolbar,
  },
  props: {
    title: { type: String, required: true },
    scrolled: { type: Boolean, default: false },
  },
  setup() {
    const emitter = inject('emitter') as MittEmitter | undefined;
    const openMenu = () => {
      emitter?.emit('open-menu');
    };
    return { menuOutline, openMenu };
  },
});
</script>

<style scoped>
.page-header {
  --background: transparent;
  --border-width: 0;
  --min-height: 56px;
  background:
    var(--liga-app-header-shine),
    var(--liga-app-header-gradient);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
  transition: box-shadow 0.25s ease;
}

.page-header--scrolled {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.32);
}

.page-header-toolbar {
  --background: transparent;
  --padding-top: env(safe-area-inset-top);
  --padding-start: 8px;
  --padding-end: 16px;
  --min-height: 56px;
}

.menu-btn {
  --color: rgba(255, 255, 255, 0.9);
  --background-hover: rgba(255, 255, 255, 0.08);
  --background-activated: rgba(255, 255, 255, 0.12);
  --border-radius: 12px;
  margin: 0 4px;
}

.menu-btn ion-icon {
  font-size: 24px;
}

.page-header-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  letter-spacing: 0.02em;
}

.header-spacer {
  width: 40px;
}
</style>
